import {
  DEFAULT_PROJECTION_DIMENSION_SETTING,
  EN_PROJECT_TYPE,
  IProjectionSetting,
  NodeTypeDefaultValueMap,
} from '@do-lib/global-interface';
import { staticImplements } from '../../interface_plugin';
import { AbstractDefaultProjectionSettingConfigProvider } from './abstract_default_projection_setting_config_provider';
import { applyUnitViewCurvesVisibilityDefault } from './unit_projection_default_overrides';
import { cloneDeep } from 'lodash-es';

/**
 * 蒂森品系默认配置获取插件
 */
@staticImplements()
export class DefaultProjectionSettingConfigProviderDisen extends AbstractDefaultProjectionSettingConfigProvider {
  static description = '蒂森品系默认配置获取插件,';

  // 标注配置 https://designorder.yuque.com/bsy5gt/fn37z0/fzevodv060e4gf7b#BZGAn
  protected static _getNodeTypeDefaultValueMap(): typeof NodeTypeDefaultValueMap {
    const nodeTypeDefaultValueMap = cloneDeep(NodeTypeDefaultValueMap);

    for (const nodeTypeKey in nodeTypeDefaultValueMap) {
      const nodeTypeSettings = nodeTypeDefaultValueMap[nodeTypeKey];
      for (const projectTypeKey in nodeTypeSettings) {
        const config = nodeTypeSettings[projectTypeKey] as IProjectionSetting;

        if (projectTypeKey === EN_PROJECT_TYPE.ASSEMBLY) {
          config.dimensionSetting = {
            ...(config.dimensionSetting ?? DEFAULT_PROJECTION_DIMENSION_SETTING),
            holeGroupLocating: false,
            holeGroupInnerLocating: false,
            holeGroupNumerical: false,
            holeGroupRoughness: false,
            holePlanar: false,
            pinHoleFill: false,
            holeAxis: false,
            holeDepth: false,
            filletNumerical: false,
            chamferNumerical: false,
            chamferLocation: false,
            pinNumerical: false,
            pinPlanar: false,
            oblongHolePlanar: false,
            oblongHoleGroupLocating: false,
            oblongHoleGroupInnerLocating: false,
            oblongHoleGroupNumerical: false,
            semicircularHolePlanar: false,
            semicircularHoleGroupLocating: false,
            semicircularHoleGroupInnerLocating: false,
            semicircularHoleGroupNumerical: false,
            parallelFace: false,
            coordinatePoint: false,
            shaftChamfer: false,
            shaftStopLocation: false,
            keyGrooveLocation: false,
            shaftDiameterSize: false,
            shaftFineMachiningLocation: false,
            hexagonHole: false,
            snapRingGrooveSize: false,
            generalDimension: false,
            bending: false,
            bendingThickness: false,
            bendingInstanceGroupNumerical: false,
            groove: false,
            cavitySize: false,
            polygon: false,
            holeDepthNumerical: false,
            counterBoreMiddleFaceLocating: false
          };
        }

        if (projectTypeKey === EN_PROJECT_TYPE.PART) {
          config.dimensionSetting = {
            ...(config.dimensionSetting ?? DEFAULT_PROJECTION_DIMENSION_SETTING),

            ncFacePoint: false,
          };
        }
      }
    }

    applyUnitViewCurvesVisibilityDefault(nodeTypeDefaultValueMap);
    return nodeTypeDefaultValueMap;
  }
}
